import { TpAssetInfo } from '../../data/assets/interfaces';

export type FormDefinitionElement = {
  id: string;
  displayName: string;
  required: boolean;
  type: string;
  helpText?: string;
  relationType?: string;
  defaultValue?: string;
};

export type FormDefinition = {
  elements: FormDefinitionElement[];
};

export type TaskDefinition = {
  displayName: string;
  description: string;
  parentAssetType: string;
  formDefinition: FormDefinition;
  taskDefinitionId: string;
  taskType: string;
};

export type TaskDefinitionList = {
  taskDefinitionList: TaskDefinition[];
};

export type TaskExecutionType = {
  taskExecutionId: string;
  taskDefinitionId: string;
  executingParameters: any;
  status: string;
  startTime: string;
  endTime: string;
  parentAssetId?: string;
  parentAssetType?: string;
  name?: string;
  assets: TpAssetInfo[];
  logAvailable: boolean;
};

export enum TASKFORM_DEFINITION_TYPES {
  STRING = 'string',
  ASSET_LIST = 'assetList',
  BOOLEAN = 'boolean',
}
